// extracted by mini-css-extract-plugin
export var searchHeader = "_79-0";
export var searchHeaderDark = "_79-1";